import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './styles.css';

const AuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing');
    const [error, setError] = useState(null);

    useEffect(() => {
        const handleAuthCallback = async () => {
            console.log('🔐 Auth Callback - Processing authorization code');
            
            // Get authorization code and state from URL parameters
            const code = searchParams.get('code');
            const state = searchParams.get('state');
            const errorParam = searchParams.get('error');
            const errorDescription = searchParams.get('error_description');

            // Log all parameters for debugging
            console.log('Auth Callback Parameters:', {
                code: code ? '***' + code.slice(-4) : null,
                state,
                error: errorParam,
                errorDescription,
                fullUrl: window.location.href
            });

            // Handle OAuth error response
            if (errorParam) {
                console.error('❌ OAuth Error:', errorParam, errorDescription);
                setError(errorDescription || errorParam);
                setStatus('error');
                return;
            }

            // Validate authorization code is present
            if (!code) {
                console.error('❌ No authorization code received');
                setError('No authorization code received from identity provider');
                setStatus('error');
                return;
            }

            try {
                setStatus('processing');

                // Store the authorization code temporarily
                // Your backend will exchange this for an access token
                sessionStorage.setItem('auth_code', code);
                if (state) {
                    sessionStorage.setItem('auth_state', state);
                }

                console.log('✅ Authorization code received and stored');
                console.log('   Code length:', code.length);
                console.log('   State:', state || 'none');

                // TODO: Send the authorization code to your backend
                // Example:
                // const response = await fetch('/api/auth/exchange', {
                //     method: 'POST',
                //     headers: { 'Content-Type': 'application/json' },
                //     body: JSON.stringify({ code, state })
                // });
                // const data = await response.json();
                // Store access token, etc.

                setStatus('success');

                // Redirect to the original destination or home page after 1 second
                setTimeout(() => {
                    const redirectTo = state || '/search';
                    console.log('🔄 Redirecting to:', redirectTo);
                    navigate(redirectTo);
                }, 1000);

            } catch (err) {
                console.error('❌ Auth callback error:', err);
                setError(err.message);
                setStatus('error');
            }
        };

        handleAuthCallback();
    }, [searchParams, navigate]);

    return (
        <main className="auth-callback-container">
            <div className="auth-callback-content">
                {status === 'processing' && (
                    <>
                        <div className="spinner" role="status" aria-live="polite">
                            <div className="spinner-circle"></div>
                        </div>
                        <h1>Authenticating...</h1>
                        <p>Please wait while we complete your sign-in.</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div className="success-icon" aria-hidden="true">✓</div>
                        <h1>Authentication Successful</h1>
                        <p>Redirecting you now...</p>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div className="error-icon" aria-hidden="true">✗</div>
                        <h1>Authentication Failed</h1>
                        <p className="error-message">{error}</p>
                        <button 
                            onClick={() => navigate('/search')}
                            className="return-button"
                        >
                            Return to Find Care
                        </button>
                    </>
                )}
            </div>
        </main>
    );
};

export default AuthCallback;
